import { Component, HostBinding, Input } from "@angular/core";

import { JustifyContentType } from "../types";

@Component({
  selector: "med-header",
  templateUrl: "./med-header.component.html",
  styleUrls: ["./med-header.component.scss"],
})
export class MedHeaderComponent {
  @Input() logoUrl = "#";
  @Input() headerAppLogo = "/assets/images/logo_uk.svg";
  @Input() justifyContent: JustifyContentType = "flex-start";

  @HostBinding("class") class = "med-header";
}
